"use client";
import Link from "next/link";
import { useState } from "react";
import { NavLink } from "../NavLink";

type TestimonialType = {
  review: string;
  shortReview: string;
  name: string;
};

export default function TestimonialCarousel({
  testimonials,
}: {
  testimonials: TestimonialType[];
}) {
  const [currentIndex, setCurrentIndex] = useState(0);
  const items = testimonials;

  const handleNext = () => {
    setCurrentIndex((prevIndex) => (prevIndex + 1) % items.length);
  };

  const handlePrev = () => {
    setCurrentIndex(
      (prevIndex) => (prevIndex - 1 + items.length) % items.length
    );
  };

  return (
    <div className="w-[90%] group3:w-9/12 group4:6/12 flex flex-col justify-center items-center bg-white outline pb-4 mb-8">
      <div className="overflow-hidden w-full">
        <div
          className="flex transition-transform duration-500"
          style={{
            transform: `translateX(-${currentIndex * 100}%)`,
          }}
        >
          {items?.map((item, index) => (
            <div
              key={index}
              className="flex-shrink-0  flex flex-col  w-full px-4 py-8 flex justify-center"
            >
              <div className="w-4/5 mx-auto text-center">
                <p className="mb-4 text-lg sm:text-xl md:text-2xl">
                  {item.shortReview}
                </p>
                <p className="font-bold">{item.name}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
      <div className="flex pb-4 ">
        <button
          className="bg-olive mr-2 text-white p-2 rounded-full"
          onClick={handlePrev}
        >
          &#8592;
        </button>

        <button
          className=" bg-olive text-white p-2 rounded-full"
          onClick={handleNext}
        >
          &#8594;
        </button>
      </div>
      <NavLink
        route="testimonials"
        text="Read the full testimonials here"
        border={true}
        styles="mx-2"
      />
    </div>
  );
}
